import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { InfoOutline } from "@mui/icons-material";
import IOSSwitch from "@components/common/Switch";
import type { DonutChartConfig } from "@store/slices/donut-chart-config-slice";

interface RollupShowAsSliceListProps {
  groups: DonutChartConfig["groups"];
  onShowAsSliceChange: (groupId: string, showAsSlice: boolean) => void;
}

const RollupShowAsSliceList: React.FC<RollupShowAsSliceListProps> = ({
  groups,
  onShowAsSliceChange,
}) => {
  const validRollups = groups.filter(
    (g) => g.sliceNames.length >= 2 && g.name.trim(),
  );

  if (validRollups.length === 0) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Show as Slice
        </Typography>
        <Tooltip title="When on, the source slices are replaced with one rendered Rollup slice. When off, source slices stay in the ring and the Rollup is available as a center-only highlight.">
          <InfoOutline sx={{ fontSize: 16, color: "text.secondary" }} />
        </Tooltip>
      </Box>
      {validRollups.map((rollup) => (
        <Box
          key={rollup.id}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {rollup.name}
          </Typography>
          <IOSSwitch
            checked={rollup.showAsSlice}
            onChange={(e) => onShowAsSliceChange(rollup.id, e.target.checked)}
            size="small"
          />
        </Box>
      ))}
    </Box>
  );
};

export default RollupShowAsSliceList;
